import { render } from "./Waitlist.vue?vue&type=template&id=6e536083&scoped=true"
import script from "./Waitlist.vue?vue&type=script&lang=js"
export * from "./Waitlist.vue?vue&type=script&lang=js"

import "./Waitlist.vue?vue&type=style&index=0&id=6e536083&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e536083"]])

export default __exports__